import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "terms-scope",
    title: "About these terms",
    body: [
      "These terms describe how a visitor may use the nartvmora website. By browsing or ordering, a visitor agrees to use it lawfully and not interfere with its security, availability or operation.",
      "Questions about these terms can be sent to east@nartvmora.site.",
    ],
  },
  {
    id: "checkout",
    title: "Checkout and payment",
    body: [
      "Checkout redirects to a third-party payment provider. An order is accepted only after successful payment confirmation and a confirmation is issued.",
      "Raw card details are entered on the provider's secure page and are not collected by the nartvmora checkout form.",
    ],
  },
  {
    id: "product-information",
    title: "Product information and pricing",
    body: [
      "We aim to present colour, fit and fabric details clearly, but screens and photography can display colour differently. Measurements are approximate and natural variations in denim washes may occur.",
      "Prices may change and may contain errors. Checkout identifies the transaction currency, delivery fee and order total before payment.",
    ],
  },
  {
    id: "orders",
    title: "Orders, availability and cancellation",
    body: [
      "An order acknowledgement confirms receipt of a request, not automatic acceptance. The sale is accepted when nartvmora confirms the order after successful payment, subject to applicable consumer law.",
      "The operator may need to cancel or limit an order affected by unavailable stock, an obvious pricing error, suspected fraud or a delivery restriction. Any captured payment would need to be returned promptly through the original payment method.",
    ],
  },
  {
    id: "acceptable-use",
    title: "Acceptable use",
    items: [
      "Do not attempt to bypass access controls, probe vulnerabilities, introduce malicious code or disrupt the service.",
      "Do not scrape, reproduce or commercially exploit site content without permission or another lawful basis.",
      "Do not submit unlawful, misleading, abusive or infringing material through a form or account feature.",
      "Do not impersonate another person or use another person's payment or contact details without authority.",
    ],
  },
  {
    id: "intellectual-property",
    title: "Intellectual property",
    body: [
      "The nartvmora name, original writing, imagery and software on this site are protected by applicable intellectual-property rights. Permission to browse does not transfer ownership or grant a right to reuse those materials commercially.",
    ],
  },
  {
    id: "third-parties",
    title: "Third-party services and links",
    body: [
      "We may rely on carriers, payment processors, hosting services or linked websites with their own terms and privacy practices. Those third parties remain responsible for their own services.",
    ],
  },
  {
    id: "disclaimers",
    title: "Disclaimers and responsibility",
    body: [
      "We take reasonable care with availability, prices and product information, but do not promise that the website will always be uninterrupted or error-free.",
      "Nothing in these terms excludes responsibility or customer rights that cannot lawfully be excluded.",
    ],
  },
  {
    id: "terms-changes",
    title: "Changes and contact",
    body: [
      "Material changes will be reflected by a revised effective date. Continued use after an update has only the effect permitted by applicable law.",
    ],
    links: [
      { to: "/privacy", label: "Read the privacy notice" },
      { to: "/returns", label: "Read the returns policy" },
      { to: "/contact", label: "Contact customer care" },
    ],
  },
];

function Terms() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Terms of Use"
      intro="Terms for browsing nartvmora, placing an order and using our services."
      updated="Effective September 2026"
      sections={sections}
      action={{ to: "/contact", label: "Contact us" }}
    />
  );
}

export default Terms;
